import { render, staticRenderFns } from "./courseTabs.vue?vue&type=template&id=583250b4&scoped=true&"
import script from "./courseTabs.vue?vue&type=script&lang=js&"
export * from "./courseTabs.vue?vue&type=script&lang=js&"
import style0 from "./courseTabs.vue?vue&type=style&index=0&id=583250b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583250b4",
  null
  
)

export default component.exports